// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataMultiselectComponent {
  name: 'awsui.Multiselect';
  label: string;
  properties: {
    disabled: string;
    selectedOptionsCount: string;
  };
}
